import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import ThemeContext from '../ThemeContext/ThemeContext';
import Attendix from '../../Assets/AttendixLogo.svg';
import AttendixDark from '../../Assets/AttendixLogoNav.svg';

function Footer() {
  const { t, i18n } = useTranslation();
  const currentYear = new Date().getFullYear();
  const { theme } = useContext(ThemeContext);

  return (
    <footer className="bg-[#fdd492dc] dark:bg-Eerie-Black/90">
      <div className="container mx-auto px-4 py-8 md:py-12 lg:px-8 text-gray-600 dark:text-gray-300">
        <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <div className="text-center md:text-left">
            <img width="100" height="42" src={theme === 'dark' ? AttendixDark : Attendix} alt="Attendix logo" className="mx-auto md:mx-0 w-32" />
            <p className="mt-4 md:mt-2">{t('Footer.description')}</p>
          </div>

        </div>
        <div className="flex flex-wrap justify-between items-start mt-6 border-t border-gray-300 pt-6">
          <div className="w-full sm:w-1/2 md:w-1/3 lg:w-1/4 space-y-4">
            <h6 className="text-lg font-medium text-Eerie-Black dark:text-gray-200">{t('Footer.categoriesTitle')}</h6>
            <ul className="space-y-2">
              <li><a href="#" className="hover:text-white dark:hover:text-Ripe-mango">About</a></li>
              <li><a href="#" className="hover:text-white dark:hover:text-Ripe-mango">Customers</a></li>
              <li><a href="#" className="hover:text-white dark:hover:text-Ripe-mango">Enterprise</a></li>
              <li><a href="#" className="hover:text-white dark:hover:text-Ripe-mango">Partners</a></li>
              <li><a href="#" className="hover:text-white dark:hover:text-Ripe-mango">Jobs</a></li>
            </ul>
          </div>
          <div className="w-full sm:w-1/2 md:w-1/3 lg:w-1/4 space-y-4">
            <h6 className="text-lg font-medium text-Eerie-Black dark:text-gray-200">{t('Footer.categoriesTitle')}</h6>
            <ul className="space-y-2">
              <li><a href="#" className="hover:text-white dark:hover:text-Ripe-mango">About</a></li>
              <li><a href="#" className="hover:text-white dark:hover:text-Ripe-mango">Customers</a></li>
              <li><a href="#" className="hover:text-white dark:hover:text-Ripe-mango">Enterprise</a></li>
              <li><a href="#" className="hover:text-white dark:hover:text-Ripe-mango">Partners</a></li>
              <li><a href="#" className="hover:text-white dark:hover:text-Ripe-mango">Jobs</a></li>
            </ul>
          </div>
          <div className="w-full sm:w-1/2 md:w-1/3 lg:w-1/4 space-y-4">
            <h6 className="text-lg font-medium text-Eerie-Black dark:text-gray-200">{t('Footer.categoriesTitle')}</h6>
            <ul className="space-y-2">
              <li><a href="#" className="hover:text-white dark:hover:text-Ripe-mango">About</a></li>
              <li><a href="#" className="hover:text-white dark:hover:text-Ripe-mango">Customers</a></li>
              <li><a href="#" className="hover:text-white dark:hover:text-Ripe-mango">Enterprise</a></li>
              <li><a href="#" className="hover:text-white dark:hover:text-Ripe-mango">Partners</a></li>
              <li><a href="#" className="hover:text-white dark:hover:text-Ripe-mango">Jobs</a></li>
            </ul>
          </div>
          {/* Repeat the column block as needed for other categories */}
          <div className="w-full sm:w-1/2 md:w-1/3 lg:w-1/4 mt-6 sm:mt-0">
            <h6 className="text-lg font-medium text-Eerie-Black dark:text-gray-200">Contact</h6>
            <ul className="space-y-2">
              <li><a href="tel:+213 556839803" className="hover:text-white dark:hover:text-Ripe-mango">+213 556839803</a></li>
              <li><a href="mailto:instant.saas.builders@gmail.com" className="hover:text-white dark:hover:text-Ripe-mango">instant.saas.builders@gmail.com</a></li>
            </ul>
          </div>
        </div>
        <div className="text-center mt-6 border-t border-gray-300 pt-4">
          <span>{t('Footer.copyRight')} {t('Footer.rightsReserved')}</span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;

                                  